import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4af16c08"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "overview-list"
};
const _hoisted_2 = {
  class: "overview-card__label"
};
const _hoisted_3 = {
  class: "overview-card__value"
};
const _hoisted_4 = {
  class: "overview-card__desc"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  props: {
    overviewList: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.overviewList, item => {
        var _item$value;
        return _openBlock(), _createElementBlock("div", {
          key: item.key,
          class: _normalizeClass(["overview-card", item.type])
        }, [_createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1), _createElementVNode("div", _hoisted_3, _toDisplayString((_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : '-'), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(item.desc), 1)], 2);
      }), 128))]);
    };
  }
});